module.exports = __webpack_public_path__ + "static/ro-workshops-9-d11d695ba2e6e9ecfbcecd685d97c922.jpg";